export var Size;
(function (Size) {
    Size[Size["XXSmall"] = 4] = "XXSmall";
    Size[Size["XSmall"] = 8] = "XSmall";
    Size[Size["Small"] = 12] = "Small";
    Size[Size["MediumSmall"] = 16] = "MediumSmall";
    Size[Size["Medium"] = 24] = "Medium";
    Size[Size["MediumLarge"] = 32] = "MediumLarge";
    Size[Size["Large"] = 40] = "Large";
    Size[Size["XLarge"] = 48] = "XLarge";
    Size[Size["XXLarge"] = 64] = "XXLarge";
    Size[Size["XXXLarge"] = 72] = "XXXLarge";
})(Size || (Size = {}));
export var Type;
(function (Type) {
    /**
     * Used for spacing between boxes
     * Applies to margin top and bottom
     */
    Type[Type["Section"] = 10] = "Section";
})(Type || (Type = {}));
//# sourceMappingURL=Spacing.js.map